module.exports = __webpack_public_path__ + "static/media/TW Headshot2.152ac97d.jpg";